import { Search } from "lucide-react";

import { FeatureGate } from "@/shared/components/FeatureGate";
import { MODULES } from "@/shared/config/modules";

import { openPalette } from "./paletteStore";

const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform);

/** The header's search box: it opens the Ctrl+K palette rather than holding state of its own. */
export default function HeaderSearch() {
  return (
    <FeatureGate module={MODULES.SEARCH}>
      <button
        type="button"
        onClick={() => openPalette()}
        aria-label="Search (Ctrl+K)"
        aria-keyshortcuts="Control+K"
        className="flex h-9 w-64 items-center gap-2 rounded-xl border border-theme-border bg-theme-surface px-3 text-sm text-theme-text-placeholder transition-colors hover:border-theme-warning-hero max-lg:hidden"
      >
        <Search size={16} className="shrink-0 text-theme-text-soft" />
        <span className="flex-1 text-left">Search…</span>
        <kbd className="rounded border border-theme-border px-1.5 py-0.5 text-[10px] font-semibold text-theme-text-soft">
          {isMac ? "⌘K" : "Ctrl K"}
        </kbd>
      </button>
    </FeatureGate>
  );
}
